// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info_config{position:relative;max-width:700px;margin:auto;font-size:15px}.textLinkMyConfigs{color:#585858!important}.alert a{text-decoration:underline!important}", ""]);
// Exports
module.exports = exports;
